module.exports = __webpack_public_path__ + "img/poli-payments.f69de36.svg";